var exports = {
  "i": "xaee3c4fa--028e7d--wrapper",
};

module.exports = exports;
